(function ($) {
  var navItems = 'header .main-nav nav > ul > li';
  var $colThreeContent = $('header .services .col-three-content');

  function setComboboxAriaAttributes() {
    const observer = new MutationObserver((mutationsList, observer) => {
        const combobox = document.querySelector('.search-bar-wrapper .select2 .selection .select2-selection[role="combobox"]');
        const listContainer = document.querySelector('.select2-selection__rendered');
        
        if (combobox && listContainer) {
            if (!listContainer.id) {
                listContainer.id = 'select2-list-container';
            }
            combobox.setAttribute('aria-label', 'Select configurations');
            combobox.setAttribute('aria-controls', listContainer.id);
            observer.disconnect();
        }
    });

    observer.observe(document, { childList: true, subtree: true });
  }

  // Call the function to start observing
  setComboboxAriaAttributes();

  function setRoleAttributeForColThreeSlides() {
    const colThreeSlides = document.querySelectorAll('.col-three.slick-slide');
    if(colThreeSlides){
      colThreeSlides.forEach(slide => {
          if (slide.classList.contains('slick-slide') && !slide.hasAttribute('role')) {
              slide.setAttribute('role', 'link');
              // Adding the aria-label
              const H5title = slide.querySelector('h5')?.textContent || '';
              const H6title = slide.querySelector('h6')?.textContent || '';
              const heading = H5title || H6title;
              if (heading) {
                slide.setAttribute('aria-label', heading);
              }
            }
        });
      }
  }
  function setRoleAttributeForTabBoxSlides() {
    const tabBoxSlides = document.querySelectorAll('.tab-box.slick-slide');
    if(tabBoxSlides){
      tabBoxSlides.forEach(slide => {
          if (slide.classList.contains('slick-slide') && !slide.hasAttribute('role')) {
              slide.setAttribute('role', 'link');
              // Adding the aria-label
              const H5title = slide.querySelector('h5')?.textContent || '';
              const H6title = slide.querySelector('h6')?.textContent || '';
              const heading = H5title || H6title;
              if (heading) {
                slide.setAttribute('aria-label', heading);
              }
          }
        });
      }
  }
  function setRoleAttributeForsliderWrap() {
    const sliderWrap = document.querySelectorAll('.slick-slide');
    if(sliderWrap){
      sliderWrap.forEach(slide => {
        if (slide.classList.contains('slick-slide') && !slide.hasAttribute('role')) {
            slide.setAttribute('role', 'link');
            // Adding the aria-label
            const H4title = slide.querySelector('h4')?.textContent || '';
            const H5title = slide.querySelector('h5')?.textContent || '';
            const H6title = slide.querySelector('h6')?.textContent || '';
            const heading = H5title || H6title || H4title;
            if (heading) {
              slide.setAttribute('aria-label', heading);
            }
        }
      });
    }
  }

  function addAriaLabelToSVG() {
    const lottieDivs = document.querySelectorAll('div.lottie');
  
    if (lottieDivs.length > 0) {
        lottieDivs.forEach((div, index) => {
            const svgs = div.querySelectorAll('svg');
            if(svgs){
              svgs.forEach((svg, svgIndex) => {
                const ariaLabel = `Triangle animation showing Lottie effects ${index + 1}, SVG ${svgIndex + 1}`;
                svg.setAttribute('aria-label', ariaLabel);
              });
            }
        });
    } 
  }

  function setAriaLabelsforCategories() {
    const colElements = document.querySelectorAll('.col-three');
    let financialsolutionscounter = 1;
    if (colElements.length > 0) {
        colElements.forEach(function (col) {
            const h6Element = col.querySelector('h6');
            const h4Element = col.querySelector('h4');
            const link = col.querySelector('.btn-wrap a');
            if (link) {
                if (h6Element && h4Element) {
                    // Both h6 and h4 are present
                    const h6Text = h6Element.textContent.trim();
                    const h4Text = h4Element.textContent.trim();
                    link.setAttribute('aria-label', `TRS - ${h4Text} - ${h6Text}`);
                } else if (h6Element) {
                    // Only h6 is present
                    const h6Text = h6Element.textContent.trim();
                    link.setAttribute('aria-label', `TRS - ${h6Text} - ${financialsolutionscounter}`);
                    financialsolutionscounter++;
                } else {
                    // Fallback when neither h4 nor h6 is present
                    link.setAttribute('aria-label', `Financial Solutions-${financialsolutionscounter}`);
                    financialsolutionscounter++;
                }
                if (!link.hasAttribute('href')) {
                    link.setAttribute('tabindex', '0'); // Make it focusable
                    link.setAttribute('role', 'button'); // Indicate it acts like a button
                }
            }
        });
      }
  }
  //https://dev.trsrentelco.com/products/tektronix-tdp1500
  function updateAriaLabelsWithTitles() {
    const cards = document.querySelectorAll('.col-three.slick-slide');
    let emptycounter = 1;
    if (cards) {
      cards.forEach(card => {
        const link = card.querySelector('.empty-link');
        const h5 = card.querySelector('h5');
        const h6 = card.querySelector('h6');
        // Use h5 if it exists, otherwise use h6
        const heading = h5 || h6;

        if (link && heading) {
          const newAriaLabel = `TRS - ${heading.textContent.trim()}`;
          link.setAttribute("role", "button");
          link.setAttribute('aria-label', newAriaLabel);
        }else{
          link.setAttribute('aria-label', `TRS Links-${emptycounter}`);
          emptycounter++;
        }
      });
    }
  }

  function enhanceButtonAccessibility() {
    const btnPrimaryLinks = document.querySelectorAll('.three-column .btn-wrap .btn-primary');
    if(btnPrimaryLinks){
      btnPrimaryLinks.forEach((link) => {
        if(!link.hasAttribute('href') || link.getAttribute('href').trim() === '') {
            link.setAttribute('tabindex', '0');
            link.setAttribute('role', 'button');
            link.setAttribute('aria-label', 'TRS Learn More Button');
        } else {
            link.setAttribute('aria-label', 'TRS Learn More Button');
          }
        });
      }
  }
  
  
  function observeAndSetRoleAttributes() {
    const observer = new MutationObserver(() => {
        setRoleAttributeForColThreeSlides();
        setRoleAttributeForTabBoxSlides();
		    setRoleAttributeForsliderWrap();
        addAriaLabelToSVG();
        setAriaLabelsforCategories();
        updateAriaLabelsWithTitles();
        enhanceButtonAccessibility();
    });
    observer.observe(document, { childList: true, subtree: true });
  }

  observeAndSetRoleAttributes();


  function addAriaLabelToViewMore() {
    const button = document.querySelector('.button-wrapper .btn-primary');
    if (button) {
        button.setAttribute('aria-label', 'TRS - Clicked here to View More');
    }
  }
  addAriaLabelToViewMore();

  function addAriaLabelToSocialLinks() {
    const socialLinks = document.querySelectorAll('#we-trs-footer .social-wrapper .social-links a');
    if (socialLinks.length > 0) {
      socialLinks.forEach(function(link) {
        const href = link.getAttribute('href');
        if (href.includes('facebook.com')) {
          link.setAttribute('aria-label', 'Go to TRS Facebook page');
        } else if (href.includes('linkedin.com')) {
          link.setAttribute('aria-label', 'Go to TRS LinkedIn page');
        } else if (href.includes('youtube.com')) {
          link.setAttribute('aria-label', 'Go to TRS YouTube page');
        }
      });
    }
  }

  function addAriaLabelsForSocialLinks() {
    // Check if the .social-links class exists on the page
    const socialLinksContainer = document.querySelector('.social-links');
    if (!socialLinksContainer) {
      return;
    }
    const socialLinks = socialLinksContainer.querySelectorAll('a');
    socialLinks.forEach(link => {
      const url = link.href;
      let socialMediaName = '';
  
      if (url.includes('facebook.com')) {
        socialMediaName = 'Facebook';
      } else if (url.includes('linkedin.com')) {
        socialMediaName = 'LinkedIn';
      } else if (url.includes('youtube.com')) {
        socialMediaName = 'YouTube';
      }
      if (socialMediaName) {
        link.setAttribute('aria-label', `Go to ${socialMediaName} Page`);
      }
    });
  }
  
  // Call the function to add aria-labels
  addAriaLabelsForSocialLinks();

  // Function to add aria-label to menu links
  function addAriaLabelToMenuLinks() {
    const menuLinks = document.querySelectorAll('#we-trs-footer .outer-wrapper .col-wrap .menu a');
    if (menuLinks.length > 0) {
      menuLinks.forEach(function(link) {
        const linkText = link.innerText.trim(); 
        link.setAttribute('aria-label', `Go to TRS ${linkText} page`);
      });
    }
  }

  // Check if social links and menu links are present, then execute the functions
  const socialLinks = document.querySelectorAll('.social-links a');
  const menuLinkss = document.querySelectorAll('.menu a');
  
  if (socialLinks.length > 0 && menuLinkss.length > 0) {
    addAriaLabelToSocialLinks();
    addAriaLabelToMenuLinks();
  }

  function addAriaLabelToProductLinks() {
    var productDetails = document.querySelectorAll('.product-detail');
    if(productDetails.length > 0){
      productDetails.forEach(function(productDetail) {
          var productNameElement = productDetail.querySelector('h5');
          var productLink = productDetail.querySelector('a');
          if (productNameElement && productLink) {
              var productName = productNameElement.textContent.trim();
              var formattedProductName = productName.replace(/\s+/g, '-'); 
              var ariaLabel = 'Learn more about ' + formattedProductName;
              productLink.setAttribute('aria-label', ariaLabel);
          }
      });
    }
  }
  // Call the function to apply aria-labels to the links
  addAriaLabelToProductLinks();

  function addAriaLabelsToAlphabetLinks() {
    var links = document.querySelectorAll('.wrapper .container ul li a');
    links.forEach(function(link) {
        var linkText = link.textContent.trim();
        if (linkText) {
            var ariaLabel = 'Go to manufacturer list that start with - ' + linkText;
            link.setAttribute('aria-label', ariaLabel);
        }
    });
  }
  // Call the function to add aria-labels
  addAriaLabelsToAlphabetLinks();

  function addAriaLabelsToManufacturerLinks() {
    setTimeout(function() {
        var manufacturerDivs = document.querySelectorAll('.col-four.full-card-hover a');
        if(manufacturerDivs.length > 0){
        manufacturerDivs.forEach(function(link) {
            var linkHref = link.getAttribute('href'); // Get the href attribute
            if (linkHref && linkHref.includes('/manufacturers/')) {
                var manufacturerName = linkHref.split('/manufacturers/')[1]; // Get the part after '/manufacturers/'
                var ariaLabel = 'Go to this Manufacturers-' + manufacturerName + ' Page';
                link.setAttribute('aria-label', ariaLabel);
            }
        });
      }
    }, 5000); // Add a delay of 500ms
  }

  addAriaLabelsToManufacturerLinks();

  function addAriaLabelsToProductLinks() {
    setTimeout(function() {
        var productCards = document.querySelectorAll('.card');
        if(productCards.length > 0){
          productCards.forEach(function(card) {
              var linkElement = card.querySelector('a.empty-link');
              var productNameElement = card.querySelector('h6');
              var productName = productNameElement ? productNameElement.textContent.trim() : 'Product';
              if(linkElement && !linkElement.hasAttribute('aria-label')) {
                  var ariaLabel = 'Product - ' + productName;
                  linkElement.setAttribute('aria-label', ariaLabel);
              }
          });
      }
    }, 5000);
  }
  // Call the function to add aria-labels with a delay
  addAriaLabelsToProductLinks();

  function addAriaLabelsToProductsLinks() {
    setTimeout(function() {
    const productCards = document.querySelectorAll(".col-four.full-card-hover");
    // Check if productCards exists and has elements
    if (productCards.length > 0) {
        productCards.forEach((card) => {
            const link = card.querySelector("a.empty-link");
            const heading = card.querySelector("h6");
            if (link && heading) {
                const ariaLabel = heading.textContent.trim();
                link.setAttribute("aria-label", ariaLabel);
            }
        });
    }
  }, 5000);
  }

  addAriaLabelsToProductsLinks();

    function addAriaLabelsToCheckboxes() {
        var checkboxes = document.querySelectorAll('.ais-RefinementList-checkbox');
        if (checkboxes.length > 0) {
        checkboxes.forEach(function(checkbox) {
            var checkboxValue = checkbox.value;
            var ariaLabel = 'TRS-' + checkboxValue;
            checkbox.setAttribute('aria-label', ariaLabel);
        });
      }
    }

    addAriaLabelsToCheckboxes();

    function addAriaLabels() {
      // Handle Learn More links (based on H4 text in .col-three)
      var serviceDivs = document.querySelectorAll('.col-three');
      if (serviceDivs.length > 0) {
        serviceDivs.forEach(function(serviceDiv) {
            var headingElement = serviceDiv.querySelector('h4'); 
            var serviceLink = serviceDiv.querySelector('.btn-wrap a'); 
            if (headingElement && serviceLink) {
                var headingText = headingElement.textContent.trim(); 
                var ariaLabel = 'Learn More about ' + headingText;   
                serviceLink.setAttribute('aria-label', ariaLabel);
            }
        });
      }
      // Handle PDF links (based on H6 text in .content-wrap)
      var pdfDivs = document.querySelectorAll('.col-three.full-card-hover');
      if (pdfDivs.length > 0) {
        pdfDivs.forEach(function(pdfDiv) {
            var headingElement = pdfDiv.querySelector('.content-wrap h6'); 
            var pdfLink = pdfDiv.querySelector('a.empty-link'); 
            if (headingElement && pdfLink) {
                var headingText = headingElement.textContent.trim(); 
                var ariaLabel = 'Read more about ' + headingText;    
                pdfLink.setAttribute('aria-label', ariaLabel); 
            }
        });
      }
    }

    // Call the function to apply aria-labels to all relevant links
    addAriaLabels();

    function addCustomAriaLabels() {
    // Define an object with URL to aria-label mappings
    var ariaLabels = {
        '/contact-us': 'Contact Us - Get in Touch with Our Team',
        '/manufacturers': 'Browse All Manufacturers - Explore Our List of Manufacturers',
        '/solutions/5g-test-solutions': 'Explore Now - Learn More About 5G Test Solutions',
        '/manufacturers/buy-or-rent-fluke-networks/fluke-networks-test-equipment#rent-or-lease': 'Go to Fluke Networks - Rent or Lease Test Equipment',
        '/manufacturers/buy-or-rent-keysight-technologies/keysight-technologies-test-equipment#rent-or-lease': 'Go to Keysight Technologies - Rent or Lease Test Equipment',
        '/why-trsrentelco' : 'Go to Why TRS Rentelco Page',
        '/resources/tco-calculator' : 'Go to Resources calculator page'
    };
    var links = document.querySelectorAll('.btn-wrap a, a.empty-link');
    links.forEach(function(link) {
        var linkHref = link.getAttribute('href');
        if (ariaLabels[linkHref]) {
            link.setAttribute('aria-label', ariaLabels[linkHref]);
        }
    });
    }

    // Call the function to apply custom aria-labels to the links
    addCustomAriaLabels();

    function addAriaLabelsToProductCards() {
      var productCards = document.querySelectorAll('.img-with-text.full-card-hover');
      var relatedProductsCounter = 1; 
      if(productCards.length > 0){
          productCards.forEach(function(card) {
          var link = card.querySelector('a.empty-link');
          var productNameElement = card.querySelector('h4');
          var productDetailsElement = card.querySelector('h5');
          if (link && productNameElement && productDetailsElement) {
                  var productName = productNameElement.textContent.trim();
                  var productDetails = productDetailsElement.textContent.trim();
                  var ariaLabel = productName + ' - ' + productDetails;
                  link.setAttribute('aria-label', ariaLabel);
            }else{
                var fallbackLabel = `Related Products-${relatedProductsCounter}`;
                link.setAttribute('aria-label', fallbackLabel);
                relatedProductsCounter++;
            }
          });
        }
    }
    // Call the function to apply the aria-labels to the product links
    addAriaLabelsToProductCards();

    function setAccessibleButtonName(buttonClass, defaultLabel) {
      var buttons = $(buttonClass);
      buttons.each(function () {
          var button = $(this);
          var buttonText = button.find('span').text().trim();
          if (!button.attr('aria-label') || buttonText === ".") {
              button.attr('aria-label', defaultLabel);
          }
      });
  }
  
  setAccessibleButtonName('.submit-btn', 'Sign up submit button');
  
  function addAriaLabelsForBlockTRSContent() {
    var blockContent = $('#block-trs-content');
    if (blockContent.length) {
        blockContent.find('a').each(function () {
            var $this = $(this);
            if (!$this.attr('aria-label')) {
                var href = $this.attr('href');
                if (href) {
                    var cleanedHref = href.replace(/[^a-zA-Z0-9]/g, ' ');
                    cleanedHref = cleanedHref.replace(/\s+/g, ' ').trim();
                    var ariaLabel = cleanedHref;
                    $this.attr('aria-label', ariaLabel);
                }
            }
        });
    }
  }

  addAriaLabelsForBlockTRSContent();

  function addAriaLabelsForEmptyLinks() {
    var btnLinks = document.querySelectorAll('.btn-wrap a');
    if(btnLinks.length > 0){
    btnLinks.forEach(function (link) {
        if (!link.getAttribute('href') || link.getAttribute('href') === '') {
            if (!link.getAttribute('aria-label')) {
                link.setAttribute('aria-label', 'Empty Link');
            }
        }
      });
    }
  }
  addAriaLabelsForEmptyLinks();
  
  function show(element) {
    $(element).css({ opacity: 1 });
  }

  $(window).on('load', function () {
    show('header .main-nav nav');
    show('header .main-nav .btn-outer');
    show('header .top-nav .row');
  });

  if ($(navItems).length) {
    $(navItems).each(function () {
      if ($(this).find('.dropdown-menu').length) {
        $(this).addClass('with-dropdown');
      }

      if ($(this).find('.menu-tabs').length) {
        $(this).addClass('has-menu-tabs');

        var firstMenuLink = $(this).find('.menu-links').first();
        var menuLinkWidth = $(firstMenuLink).innerWidth();
        var dropdownOffsetLeft = (menuLinkWidth / 2) * -1 + 'px';

        $(this).find('.menu-box').css('left', dropdownOffsetLeft);
      }
    });

    $colThreeContent.each(function () {
      if (this.childElementCount === 0) {
        $(this).addClass('blank-element');
      }
    });
  }

  var navItemsWithDropdown = 'header .main-nav nav > ul > li.with-dropdown';

  if ($(navItemsWithDropdown).length) {
    $(navItemsWithDropdown).on({
      mouseenter: function () {
        if ($(window).width() > 991) {
          $('body').addClass('stop-scroll');

          $(this).siblings().removeClass('active-nav').find('.dropdown-menu.open').removeClass('open');
          $(this).addClass('active-nav').find('.dropdown-menu').addClass('open');
        }
      },
      mouseleave: function () {
        $('body').removeClass('stop-scroll');
        if ($(window).width() > 991) {
          $(this).find('.menu-links ul li').removeClass('active');
          $(this).removeClass('active-nav').find('.dropdown-menu').removeClass('open');

          if ($(this).find('.menu-tabs').length) {
            $(this).find('.menu-tabs').removeClass('show').find('.tab-panel').removeClass('active');

            var firstMenuLink = $(this).find('.menu-links').first();
            var menuLinkWidth = $(firstMenuLink).innerWidth();
            var dropdownOffsetLeft = (menuLinkWidth / 2) * -1 + 'px';

            $(this).find('.menu-box').css('left', dropdownOffsetLeft);

            $('body').removeClass('stop-scroll');
          }
        }
      },
      click: function () {
        if ($(window).width() <= 991) {
          $('body').toggleClass('stop-scroll');
          $(this).siblings().removeClass('active-nav ').find('.dropdown-menu.open').removeClass('open');
          $(this).toggleClass('active-nav');
          $(this).find('.dropdown-menu').toggleClass('open');
          $(this).find('.dropdown-menu .menu-tabs').first().addClass('show');
        }
      },
    });
  }

  //Active nav on load
  var path = window.location.pathname;
  $('header nav ul li a[href="' + path + '"]')
    .parents('.with-dropdown')
    .eq(0)
    .addClass('active-menu');

  //Click prevent below <1335
  if ($(window).width() <= 1335) {
    $(navItemsWithDropdown + ' > a').on('click', function (e) {
      e.preventDefault();
    });
  }

  // //products menuLinks click preventDefault
  if ($(window).width() < 992) {
    $(
      'header .main-nav nav > ul > li.products .dropdown-menu .menu-links .white-circle-link a, header .main-nav nav > ul > li.products .dropdown-menu .menu-links .black-circle-link a'
    ).on('click', function (e) {
      e.preventDefault();
    });
  }

  var dropdownMenu = 'header .main-nav nav > ul > li.with-dropdown .dropdown-menu';

  if ($(dropdownMenu).length) {
    $(dropdownMenu).on('click', function (event) {
      event.stopPropagation();
    });
  }

  var menuLinks = 'header .dropdown-menu .menu-links > ul > li';

  if ($(menuLinks).length) {
    $(menuLinks).on({
      mouseenter: function () {
        if ($(window).width() > 991) {
          if (!$(this).hasClass('active')) {
            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            var adjMenuTabs = $(this).closest('.menu-links').siblings('.menu-tabs');
            var tabId = this.dataset.tabId;

            if (tabId) {
              $(adjMenuTabs).find('.menu-links ul li').removeClass('active');

              var firstMenuLink = $(this).closest('.dropdown-menu').find('.menu-links').first();
              var menuLinkWidth = $(firstMenuLink).innerWidth();

              if ($(window).width() >= 768) {
                var dropdownOffsetLeft = menuLinkWidth * -1 + 'px';

                $(this).closest('.menu-box').animate(
                  {
                    left: dropdownOffsetLeft,
                  },
                  200
                );
              } else {
                var prevOffsetLeft = parseInt($(this).closest('.menu-box').css('left'), 10);
                var dropdownOffsetLeft = menuLinkWidth * -1 + prevOffsetLeft + 'px';

                $(this).closest('.menu-box').animate(
                  {
                    left: dropdownOffsetLeft,
                  },
                  200
                );
              }

              $(adjMenuTabs).addClass('show');
              $(adjMenuTabs).find('.tab-panel').removeClass('active');
              $(adjMenuTabs)
                .find('.tab-panel#' + tabId)
                .addClass('active');
            } else {
              $(adjMenuTabs).find('.menu-links ul li').removeClass('active');
              $(adjMenuTabs).find('.tab-panel').removeClass('active');
              $(adjMenuTabs).removeClass('show');
            }
          }
        }
      },
      click: function () {
        if ($(window).width() > 991) {
          if (!$(this).hasClass('active') && $(this).closest('.menu-links').hasClass('sub-menu-links')) {
            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            var adjMenuTabs = $(this).closest('.menu-links').siblings('.menu-tabs');
            var tabId = this.dataset.tabId;

            if (tabId) {
              $(adjMenuTabs).find('.menu-links ul li').removeClass('active');

              var firstMenuLink = $(this).closest('.dropdown-menu').find('.menu-links').first();
              var menuLinkWidth = $(firstMenuLink).innerWidth();

              if ($(window).width() >= 768) {
                var dropdownOffsetLeft = menuLinkWidth * -1 + 'px';

                $(this).closest('.menu-box').animate(
                  {
                    left: dropdownOffsetLeft,
                  },
                  200
                );
              } else {
                var prevOffsetLeft = parseInt($(this).closest('.menu-box').css('left'), 10);
                var dropdownOffsetLeft = menuLinkWidth * -1 + prevOffsetLeft + 'px';

                $(this).closest('.menu-box').animate(
                  {
                    left: dropdownOffsetLeft,
                  },
                  200
                );
              }

              $(adjMenuTabs).addClass('show');
              $(adjMenuTabs).find('.tab-panel').removeClass('active');
              $(adjMenuTabs)
                .find('.tab-panel#' + tabId)
                .addClass('active');
            } else {
              $(adjMenuTabs).find('.menu-links ul li').removeClass('active');
              $(adjMenuTabs).find('.tab-panel').removeClass('active');
              $(adjMenuTabs).removeClass('show');
            }
          }
        }

        if ($(window).width() <= 991) {
          if (
            $(this).closest('.with-dropdown').hasClass('manufacturers') ||
            $(this).closest('.with-dropdown').hasClass('solutions')
          ) {
            return;
          }

          $(this).siblings().removeClass('active');
          $(this).addClass('active');

          var adjMenuTabs = $(this).closest('.menu-links').siblings('.menu-tabs');
          var tabId = this.dataset.tabId;

          if (tabId) {
            $(adjMenuTabs).find('.menu-links ul li').removeClass('active');

            var firstMenuLink = $(this).closest('.dropdown-menu').find('.menu-links').first();
            var menuLinkWidth = $(firstMenuLink).innerWidth();

            $(adjMenuTabs).addClass('show');
            $(adjMenuTabs).find('.tab-panel').removeClass('active');
            $(adjMenuTabs)
              .find('.tab-panel#' + tabId)
              .addClass('active');

            if (!$(this).closest('ul').hasClass('featured-links')) {
              var prevOffsetLeft = parseInt($(this).closest('.menu-box').css('left'), 10);
              var dropdownOffsetLeft = prevOffsetLeft + menuLinkWidth * -1 + 'px';
              var dropdownHeight = $(adjMenuTabs).outerHeight();

              $(this).closest('.menu-box').animate(
                {
                  left: dropdownOffsetLeft,
                  height: dropdownHeight,
                },
                200
              );
            }
          } else {
            $(adjMenuTabs).find('.menu-links ul li').removeClass('active');
            $(adjMenuTabs).find('.tab-panel').removeClass('active');
            // $(adjMenuTabs).removeClass("show");
          }
        }
      },
    });
  }

  var goBack = 'header .dropdown-menu .menu-links .back-btn';

  $(goBack).on('click', function () {
    var currMenuLink = $(this).closest('.menu-links');
    var prevMenuLink = $(this).closest('.menu-tabs').siblings('.menu-links');
    var menuLinkWidth = $(currMenuLink).innerWidth();
    var prevOffsetLeft = parseInt($(this).closest('.menu-box').css('left'), 10);
    var dropdownOffsetLeft = prevOffsetLeft + menuLinkWidth + 'px';
    var dropdownHeight = $(prevMenuLink).outerHeight();

    $(this)
      .closest('.menu-box')
      .animate(
        {
          left: dropdownOffsetLeft,
          height: dropdownHeight,
        },
        200,
        function () {
          $(currMenuLink).closest('.tab-panel').removeClass('active');
        }
      );
  });

  var winWidth = $(window).width();
  $(window).on('resize', function () {
    winWidth = $(window).width();
    //close dropdown
    $(navItemsWithDropdown)
      .siblings()
      .removeClass('active-nav')
      .find('.dropdown-menu.open')
      .removeClass('open');
    $('header li.has-menu-tabs .menu-box').removeAttr('style');
    if (winWidth <= 991) {
      $('body').removeClass('stop-scroll');
      $('header .main-nav nav').slideUp();
      $('header .hamburger').removeClass('active');
      header.removeClass('hide-utility-nav');
    }
  });

  /**
   * Header Scroll Functionality
   */

  var mainNavMenu = 'header .main-nav nav > ul > li.has-dropdown';
  var prevScrollPos = $(window).scrollTop();
  var header = $('header');
  const headerDiv = document.querySelector('header');
  const srchOverlay = document.querySelector('.search-overlay');
  var winWidth = $(window).width();
  var utilityNavBottomPos = 0;
  if (header.length) {
    utilityNavBottomPos = $('header .top-nav').position().top + $('header .top-nav').outerHeight();
  }
  var stickyNav = $('.sticky-nav');
  $(window).on('scroll', function () {
    var currentScrollPos = $(window).scrollTop();

    if (currentScrollPos > prevScrollPos && currentScrollPos > 0) {
      // we are scrolling down
      header.addClass('hide-nav');
      $('body').removeClass('scrolling-up').addClass('scrolling-down');
      stickyNav.removeClass('nav-show');
    } else if (currentScrollPos < prevScrollPos && currentScrollPos < utilityNavBottomPos) {
      // we are scrolling up and touched utility nav
      if (currentScrollPos <= 130) {
        header.removeClass('fixed hide-utility-nav');
      }
      header.removeClass('hide-nav hide-utility-nav');
      stickyNav.addClass('nav-show');
    } else if (currentScrollPos < prevScrollPos) {
      // we are scrolling up

      header.removeClass('hide-nav relative').addClass('hide-utility-nav fixed');
      setTimeout(function () {
        headerDiv.classList.remove('search-clicked');
        $('.aa-Panel').remove();
        if (winWidth <= 991) {
          srchOverlay.style.display = "none";
        } 
      }, 500);
      $('body').removeClass('scrolling-down').addClass('scrolling-up');
      stickyNav.addClass('nav-show');
    }
    prevScrollPos = currentScrollPos;
    $(mainNavMenu).find('.sub-menu').removeClass('active');
  });

  var searchOverlay = '.search-overlay';
  var searchBtn = 'header .search-btn';
  var searchInput = 'header .search-box input.ais-SearchBox-input.aa-input';
  var resetClear = '#globalsearchbox .aa-ClearButton';
  const headers = document.querySelector('header');
  const searchOverlays = document.querySelector('.search-overlay');
  var windowWidth = $(window).width();
  const cookieValue = document.cookie.split('; ').find((row) => row.startsWith('_ALGOLIA='))?.split('=')[1];
  var getval = localStorage.getItem("searchIMG",cookieValue);
  if (getval == undefined || getval == null ) {
      $('.search-btn').addClass('show-newIcon');
  } else if(localStorage.getItem("searchIMG",cookieValue) == 0){
      $('.search-btn').removeClass('show-newIcon');
  }else {
      $('.search-btn').addClass('show-newIcon');
  }
  $(window).resize(function() {
    $(resetClear).on('click',function(e){
          if (windowWidth >= 991) {
            setTimeout(function () {
            $('.aa-Panel').remove();
            headers.classList.remove('search-clicked');
          }, 100);
        } else {
          setTimeout(function () {
            $('.aa-Panel').remove();
            headers.classList.remove('search-clicked');
            searchOverlays.style.display = "none";
          }, 200);
        }
      });
    });

    $(searchBtn).on('click', function () {
      $('.search-btn').removeClass('show-newIcon');
      localStorage.setItem("searchIMG", '0');
      if($("#globalsearchbox .aa-DetachedSearchButton").length == 1){
          $("#globalsearchbox .aa-DetachedSearchButton").trigger("click");
      }
      setTimeout(function () {
        $('#globalsearchbox .aa-Input').focus();
        if($(".aa-DetachedFormContainer .aa-DetachedCancelButton").length == 1){
            $(".aa-DetachedFormContainer .aa-DetachedCancelButton").on('click',function(e){
                headers.classList.remove('search-clicked');
            });
        }
      }, 200);
      
      if (winWidth <= 991) {
        $(searchOverlay).fadeIn();
        $('body').css({ position: 'relative' });
      }
      $('header').addClass('search-clicked');
      if ($('.hamburger').hasClass('active')) {
        $('.hamburger').removeClass('active');
      }
    });

  // $(searchBtn).on('click', function () {
  //   setTimeout(function () {
  //     $('#globalsearchbox .ais-SearchBox-input').focus();
  //   }, 100);
  //   if (winWidth <= 991) {
  //     $(searchOverlay).fadeIn();
  //     $('body').css({ position: 'relative' });
  //   }
  //   $('header').addClass('search-clicked');
  //   if ($('.hamburger').hasClass('active')) {
  //     $('.hamburger').removeClass('active');
  //   }
  // });

  $(searchOverlay).on('click', function () {
    if (winWidth <= 991) {
      $(searchInput).val('');
      $(searchOverlay).fadeOut();
      $('header').removeClass('search-clicked');
    } else {
      $(searchInput).val('');
      $('header').removeClass('search-clicked');
    }
  });

  /**
   * Hamburger functionality
   */
  var navLink = 'header .main-nav .row nav > ul > li';
  var navMenu = 'header .main-nav .row nav';
  var toggleBtn = 'header .main-nav .row .hamburger';
  $(toggleBtn).on('click', function () {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      if ($('header').hasClass('search-clicked')) {
        $('header').removeClass('search-clicked');
      }
      $(navMenu).fadeIn(function () {
        $('body').addClass('stop-scroll');
      });
    } else {
      $(navMenu).fadeOut(function () {
        $('body').removeClass('stop-scroll');
        $(navLink).removeClass('no-border');
        $('header .main-nav .row nav > ul > li > .nav-links').removeClass('active');
        $('.sub-menu.active').removeClass('active');
      });
    }
  });

  $(function () {
    $(
      'header .products a, header .products h6, header .products p, header .manufacturers a, header .manufacturers h6, header .manufacturers p'
    ).each(function () {
      $(this).html($(this).html().replace(/&amp;/g, '&'));
    });

    // Workaround to align Products dropdown [links] and [green-arrow-with-line] with each other.
    $('header .products .tab-panel > .menu-links ul li a').each(function () {
      var maxLength = 22;

      if ($(this).text().trim().length > maxLength) {
        var prevLength = 0;
        var isBreakAdded = false;

        var newLine = $(this).text().trim().split(' ').map(function(word) {
          if (((word.length + prevLength) > maxLength) && !isBreakAdded) {
            isBreakAdded = true;
            prevLength += word.length;
            return ('<br /> ' + word);
          } else {
            prevLength += word.length;
            return word;
          }
        }).join(' ');

        $(this).empty().html(newLine);
      }
    });
  });

  function updateBreadcrumbAriaLabelsAndTabindex() {
    // Select all breadcrumb sections
    const breadcrumbs = document.querySelectorAll(".sticky-breadcrumb .content-wrapper");

    if (breadcrumbs) {
        breadcrumbs.forEach(breadcrumb => {
            const links = breadcrumb.querySelectorAll(".content a");

            if (links) {
                links.forEach((link, index) => {
                    let ariaLabel = "";
                    if (link.hasAttribute("href")) {
                        const href = link.getAttribute("href");
                        if (href === "") {
                            const currentPath = window.location.pathname.replace(/[^a-zA-Z0-9\-]/g, " ").trim();
                            ariaLabel = `TRS - ${currentPath}`;
                        } else {
                            const cleanedLabel = href.replace(/[^a-zA-Z0-9\-]/g, " ").trim();
                            ariaLabel = `TRS - ${cleanedLabel}`;
                        }

                        link.setAttribute("aria-label", ariaLabel);
                    }
                    
                    if (index === links.length - 1) {
                        link.setAttribute("tabindex", "0");
                        link.setAttribute("role", "button");
                    }
                });
            }
        });
    }
}
updateBreadcrumbAriaLabelsAndTabindex();




function addAriaLabelToShowPdfSection() {
  const buttons = document.querySelectorAll('.show-pdf-section object p a');
  const ariaLabelCounts = {};

  buttons.forEach((button, index) => {
    const baseLabel = 'TRS - Resource PDF';
    let ariaLabel = baseLabel;
    if (ariaLabelCounts[ariaLabel] !== undefined) {
      ariaLabelCounts[ariaLabel]++;
      ariaLabel = `${baseLabel}-${ariaLabelCounts[ariaLabel]}`;
    } else {
      ariaLabelCounts[ariaLabel] = 0;
    }
    button.setAttribute('aria-label', ariaLabel);
  });
}

addAriaLabelToShowPdfSection();

function addAccessibleNameToObjects() {
  const objects = document.querySelectorAll('object:not([aria-label]):not([title])');
  if(objects){
    objects.forEach(object => {
      const dataUrl = object.getAttribute('data');
      if (dataUrl) {
        const fileName = dataUrl.substring(dataUrl.lastIndexOf('/') + 1).replace('.pdf', '');
        object.setAttribute('aria-label', `PDF : ${fileName}`);
      }
    });
  }
}

addAccessibleNameToObjects();


// function addAriaLabelsToLinks() {
//   setTimeout(() => {
//   const textLinks = document.querySelectorAll('a.text-link');
//   if (textLinks.length > 0) {
//       textLinks.forEach(function(link) {
//           const spanText = link.querySelector('span')?.textContent;
//           if (spanText) {
//               link.setAttribute('aria-label', spanText);
//           }
//       });
//     } 
//   }, 2000);
// }
// addAriaLabelsToLinks();

function addAriaLabelsToNavLinks() {
  const navLinks = document.querySelectorAll('.main-nav nav ul li a');
  const labelCounter = {};
  
  if (navLinks.length > 0) {
      navLinks.forEach(function(link) {
          const linkText = link.textContent.trim();
          
          if (linkText) {
              if (!labelCounter[linkText]) {
                  labelCounter[linkText] = 0;
              }
              labelCounter[linkText]++;
              const uniqueLabel = labelCounter[linkText] > 1 
                  ? `${linkText} -${labelCounter[linkText] - 1}` 
                  : linkText;
              link.setAttribute('aria-label', uniqueLabel);
          }
      });
  } 
}

addAriaLabelsToNavLinks();

function updateAriaLabels() {
  const menuItems = document.querySelectorAll('.main-sticky-menu a[aria-label]');
  if(menuItems){
    menuItems.forEach(item => {
      const currentLabel = item.getAttribute('aria-label');
      if (currentLabel) {
        item.setAttribute('aria-label', `sticky-menu-${currentLabel}`);
      }else {
        const linkText = item.textContent.trim();
        if (linkText) {
          item.setAttribute('aria-label', `TRS-sticky-menu-${linkText}`);
        }
      }
    });
  }
}

updateAriaLabels();

function updateAriaLabelsWithUniqueness() {
  const textLinks = document.querySelectorAll('.partner-resources .container .content-wrapper .item .text-link');
  const ariaLabelTracker = new Map();
  textLinks.forEach(link => {
      const span = link.querySelector('span');
      if (span && span.textContent.trim()) {
          let baseLabel = span.textContent.trim();
          let uniqueLabel = baseLabel;
          let count = ariaLabelTracker.get(baseLabel) || 0;
          if (count > 0) {
              uniqueLabel = `${baseLabel}-${count + 1}`;
          }
          link.setAttribute('aria-label', uniqueLabel);
          ariaLabelTracker.set(baseLabel, count + 1);
      }
  });
}

updateAriaLabelsWithUniqueness();

function addAriaLabelsToRadioButtons() {
  // Select all radio buttons
  const radioButtons = document.querySelectorAll('input[type="radio"]');
  if(radioButtons){
  radioButtons.forEach((radio) => {
    if (!radio.hasAttribute('aria-label')) {
      const nameField = radio.getAttribute('name') || 'Radio button';
      const valueField = radio.getAttribute('value') || 'Value';
      if (nameField || valueField) {
          radio.setAttribute('aria-label', `TRS - ${nameField} - ${valueField}`);
      } else {
          radio.setAttribute('aria-label', 'TRS - Radio Option');
        }
      }
    });
  }
}

addAriaLabelsToRadioButtons();


function makeLinksAccessible() {
  const links = document.querySelectorAll('a.play-icon');

  links.forEach(link => {
    if (!link.hasAttribute('href')) {
      link.setAttribute('tabindex', '0');
      link.setAttribute('role', 'button');
      if (!link.hasAttribute('aria-label')) {
        const dataSrc = link.getAttribute('data-src');
        const label = dataSrc ? `Play video from ${dataSrc}` : 'Play video';
        link.setAttribute('aria-label', label);
      }
    }
  });
}

// Call the function
makeLinksAccessible();


})(jQuery);
